import axios from 'axios'
let authImage = {}
function authImg (el, { value, oldValue }) {
  if (!value || value == oldValue) return
  axios.get(value, { responseType: 'blob' }).then(res => {
    const url = URL.createObjectURL(res.data)
    el.style['background-image'] = `url(${url})`
    el.onload = () => {
      URL.revokeObjectURL(url)
    }
  }).catch(() => { el.style['background-image'] = 'none' })
}
authImage.install = function (Vue) {
  Vue.directive('authImage', {
    bind: (el, binding) => authImg(el, binding),
    componentUpdated: (el, binding) => authImg(el, binding)
  })
}
export default authImage
